import React, { useState, useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';

export default function TallyItemUsageReport() {
  const { id: itemId } = useParams();
  const [searchParams] = useSearchParams();
  const startDate = searchParams.get('startDate') || '';
  const endDate = searchParams.get('endDate') || '';
  const [showIframe, setShowIframe] = useState(false);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://rlugroup.in/api';
  const pdfBaseUrl = apiBaseUrl.replace('/api', '') || 'https://rlugroup.in';
  const dataUrl = `${apiBaseUrl}/tally/items/${itemId}/usage-report?startDate=${startDate}&endDate=${endDate}&pdf=true`;
  const url = `${pdfBaseUrl}/pdf/convert?fileName=rlugroup-tally-item-usage.hbs&id_field=item.Name&format=A4&margintop=0.5cm&url=${encodeURIComponent(dataUrl)}`;

  // isMobile from react-device-detect excludes tablets automatically
  const isMobilePhone = isMobile || isTablet;

  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `tally-item-usage-${itemId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback to opening in new tab
      window.open(url, '_blank');
    }
  };

  useEffect(() => {
    // Delay iframe rendering to ensure PDF service is ready (for desktop and tablets only)
    if (!isMobilePhone) {
      setTimeout(() => setShowIframe(true), 150);
    }
  }, [isMobilePhone]);

  if (isMobilePhone) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#f3f4f6'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px 30px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="14 2 14 8 20 8" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="12" y1="18" x2="12" y2="12" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="9" y1="15" x2="12" y2="18" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="15" y1="15" x2="12" y2="18" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 style={{ 
            marginBottom: '10px', 
            color: '#374151',
            fontSize: '24px',
            fontWeight: '600'
          }}>
            Tally Item Usage Report
          </h2>
          <p style={{ 
            color: '#6B7280', 
            marginBottom: '30px',
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            Tap the button below to view or download the PDF report for this item.
          </p>
          <button
            onClick={() => window.open(url, '_blank')}
            style={{
              backgroundColor: '#4F46E5',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '14px 28px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '12px'
            }}
          >
            Open PDF Report
          </button>
          <button
            onClick={handleDownload}
            style={{
              backgroundColor: 'white',
              color: '#4F46E5',
              border: '2px solid #4F46E5',
              borderRadius: '8px',
              padding: '12px 28px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            Download PDF
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh', backgroundColor: '#f3f4f6' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 20px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e5e7eb',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#111827' }}>
          Tally Item Usage Report
        </h2>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={handleDownload}
            style={{
              backgroundColor: '#4F46E5',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 16px',
              fontSize: '13px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Download PDF
          </button>
        </div>
      </div>
      {showIframe ? (
        <object 
          data={url} 
          type="application/pdf" 
          width="100%" 
          height="100%" 
          aria-label="Tally Item Usage Report PDF"
          style={{ border: 'none' }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            textAlign: 'center',
            padding: '20px'
          }}>
            <p style={{ color: '#6B7280', marginBottom: '16px' }}>
              Unable to display PDF preview.
            </p>
            <button
              onClick={() => window.open(url, '_blank')}
              style={{
                backgroundColor: '#4F46E5',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Open PDF in New Tab
            </button>
          </div>
        </object>
      ) : (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'calc(100% - 60px)'
        }}>
          <div style={{ textAlign: 'center' }}>
            <svg className="animate-spin" width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 16px' }}>
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#4F46E5" strokeWidth="4" />
              <path className="opacity-75" fill="#4F46E5" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <p style={{ color: '#6B7280', fontSize: '14px' }}>Loading report preview...</p>
          </div>
        </div>
      )}
    </div>
  );
}
